module.exports = __webpack_public_path__ + "static/media/global_card2.dabd7fb5.svg";